import React from 'react';

import classes from './Input.module.css';

const input = (props) => {
  let inputElement = null;

  const inputClasses = [classes.InputElement];
  const labelStyle = {
    position: 'absolute',
    left: 0,
    top: !props.focus ? 6 : -28,
    transition: 'all 300ms ease-in-out'
  };

  if (props.invalid && props.shouldValidate && props.touched) {
    inputClasses.push(classes.Invalid);
  }

  switch (props.elementType) {
    case 'input':
      inputElement = (
        <input
          className={inputClasses.join(' ')}
          {...props.elementConfig}
          value={props.value}
          onChange={props.changed}
          onFocus={props.onFocused}
          onBlur={props.onBlured}
        />
      );
      break;
    case 'textarea':
      inputElement = (
        <textarea
          className={inputClasses.join(' ')}
          {...props.elementConfig}
          value={props.value}
          onChange={props.changed}
          onFocus={props.onFocused}
          onBlur={props.onBlured}
        />
      );
      break;
    case 'select':
      inputElement = (
        <select
          className={inputClasses.join(' ')}
          value={props.value}
          onChange={props.changed}
          onFocus={props.onFocused}
          onBlur={props.onBlured}
          id={props.id}
        >
          {props.elementConfig.options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.displayValue}
            </option>
          ))}
        </select>
      );
      break;
    default:
      inputElement = (
        <input
          className={inputClasses.join(' ')}
          {...props.elementConfig}
          value={props.value}
          onChange={props.changed}
        />
      );
  }
  return (
    <div className={classes.Input}>
      <label className={classes.Label} htmlFor={props.id} style={labelStyle}>
        {props.label}
      </label>
      {inputElement}
    </div>
  );
};

export default input;
